import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecuritySettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M18 0L2 6.54545V16.3636C2 25.4455 8.82667 33.9382 18 36C27.1733 33.9382 34 25.4455 34 16.3636V6.54545L18 0ZM18 9.81818C20.4889 9.81818 22.9778 11.6182 22.9778 13.9091V16.3636C24.0444 16.3636 25.1111 17.3455 25.1111 18.4909V24.2182C25.1111 25.2 24.0444 26.1818 22.8 26.1818H13.0222C11.9556 26.1818 10.8889 25.2 10.8889 24.0545V18.3273C10.8889 17.3455 11.9556 16.3636 13.0222 16.3636V13.9091C13.0222 11.6182 15.5111 9.81818 18 9.81818ZM18 11.7818C16.5778 11.7818 15.3333 12.6 15.3333 13.9091V16.3636H20.6667V13.9091C20.6667 12.6 19.4222 11.7818 18 11.7818Z",
		fill: "currentColor"
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4928_6588",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			fill: "white",
			transform: "translate(0 0.0644531)"
		})
	}) })]
});
export default SvgSecuritySettings;
